import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["Data", "Devices"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV2Data: build.query<GetV2DataApiResponse, GetV2DataApiArg>({
        query: (queryArg) => ({
          url: `/v2/Data`,
          params: {
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            UnitId: queryArg.unitId,
            UnitTypeInputId: queryArg.unitTypeInputId,
            AggregateType: queryArg.aggregateType,
            DataType: queryArg.dataType,
            Start: queryArg.start,
            End: queryArg.end,
          },
        }),
        providesTags: ["Data"],
      }),
      putAnalogDataChannel: build.mutation<
        PutAnalogDataChannelApiResponse,
        PutAnalogDataChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/AnalogDataChannels/${queryArg.channelKey}`,
          method: "PUT",
          body: queryArg.putAnalogDataChannelDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putCalibratableElectricCurrentDataChannels: build.mutation<
        PutCalibratableElectricCurrentDataChannelsApiResponse,
        PutCalibratableElectricCurrentDataChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/CalibratableElectricCurrent`,
          method: "PUT",
          body: queryArg.putCalibratableElectricCurrentDataChannelsDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putCalibratableFlowDataChannels: build.mutation<
        PutCalibratableFlowDataChannelsApiResponse,
        PutCalibratableFlowDataChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/CalibratableFlowDataChannels`,
          method: "PUT",
          body: queryArg.putCalibratableFlowDataChannelsDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putDataIntervalConfiguration: build.mutation<
        PutDataIntervalConfigurationApiResponse,
        PutDataIntervalConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/DataIntervalConfiguration`,
          method: "PUT",
          body: queryArg.putDataIntervalConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putMBusDataChannel: build.mutation<
        PutMBusDataChannelApiResponse,
        PutMBusDataChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/MBus/${queryArg.channelKey}`,
          method: "PUT",
          body: queryArg.putMBusDataChannelDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putPluginDataChannelConfiguration: build.mutation<
        PutPluginDataChannelConfigurationApiResponse,
        PutPluginDataChannelConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/${queryArg.pluginName}/DataChannels/${queryArg.channelKey}/Configuration`,
          method: "PUT",
          body: queryArg.putPluginDataChannelConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetV2DataApiResponse = /** status 200 OK */ DataDto[];
export type GetV2DataApiArg = {
  orderBy?: "Timestamp" | "Value";
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  unitId: number;
  unitTypeInputId: number;
  aggregateType: string;
  dataType: string;
  start: string;
  end?: string;
};
export type PutAnalogDataChannelApiResponse = unknown;
export type PutAnalogDataChannelApiArg = {
  deviceId: number;
  channelKey: string;
  putAnalogDataChannelDto: PutAnalogDataChannelDto;
};
export type PutCalibratableElectricCurrentDataChannelsApiResponse = unknown;
export type PutCalibratableElectricCurrentDataChannelsApiArg = {
  deviceId: number;
  putCalibratableElectricCurrentDataChannelsDto: PutCalibratableElectricCurrentDataChannelsDto;
};
export type PutCalibratableFlowDataChannelsApiResponse = unknown;
export type PutCalibratableFlowDataChannelsApiArg = {
  deviceId: number;
  putCalibratableFlowDataChannelsDto: PutCalibratableFlowDataChannelsDto;
};
export type PutDataIntervalConfigurationApiResponse = unknown;
export type PutDataIntervalConfigurationApiArg = {
  deviceId: number;
  putDataIntervalConfigurationDto: PutDataIntervalConfigurationDto;
};
export type PutMBusDataChannelApiResponse = unknown;
export type PutMBusDataChannelApiArg = {
  deviceId: number;
  channelKey: string;
  putMBusDataChannelDto: PutMBusDataChannelDto;
};
export type PutPluginDataChannelConfigurationApiResponse = unknown;
export type PutPluginDataChannelConfigurationApiArg = {
  deviceId: number;
  pluginName: string;
  channelKey: string;
  putPluginDataChannelConfigurationDto: PutPluginDataChannelConfigurationDto;
};
export type DataDto = {
  timestamp?: string;
  value?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PutAnalogDataChannelDto = {
  targetDataType?: string | null;
  conversionFactor?: number | null;
  conversionOffset?: number | null;
};
export type CalibrationType =
  | "Level2ApparentPower"
  | "Level2Current"
  | "PowerDisaggregation"
  | "Level1";
export type PutCalibratableElectricCurrentDataChannelsDto = {
  calibrationType?: CalibrationType;
  calibrationFactor?: number | null;
};
export type PutCalibratableFlowDataChannelsDto = {
  volumeConstant?: number | null;
  flowPipeDiameter?: number | null;
};
export type DataInterval =
  | "Minute"
  | "Minutes5"
  | "Seconds20Boost"
  | "Seconds3Boost"
  | "Minutes30"
  | "Inactive"
  | "Second"
  | "Custom";
export type PutDataIntervalConfigurationDto = {
  dataInterval?: DataInterval;
};
export type PutMBusDataChannelDto = {
  targetDataType?: string | null;
  conversionFactor?: number;
  conversionOffset?: number;
};
export type PutPluginDataChannelConfigurationDto = object;
export const {
  useGetV2DataQuery,
  usePutAnalogDataChannelMutation,
  usePutCalibratableElectricCurrentDataChannelsMutation,
  usePutCalibratableFlowDataChannelsMutation,
  usePutDataIntervalConfigurationMutation,
  usePutMBusDataChannelMutation,
  usePutPluginDataChannelConfigurationMutation,
} = injectedRtkApi;
